import { Component } from '@angular/core';

@Component({
  selector: 'app-orgnotificationlist',
  templateUrl: './orgnotificationlist.component.html',
  styleUrl: './orgnotificationlist.component.css'
})
export class OrgnotificationlistComponent {
  previewhtml: any;
  textarea: any;
  public notificationlist: Array<any> =
    [
      { title: "entry 1", description: "entry 1 description" },
      { title: "entry 2", description: "entry 2 description" },
      { title: "entry 3", description: "entry 3 description" },
    ]

  showpreview() {
    this.textarea = document.getElementById("textareamarkup");
    this.previewhtml = this.textarea.value
  };
}
